let url = "";

if (process.env.NODE_ENV === 'development') {
	url = "http://localhost:8000";
} else if (process.env.REACT_APP_STAGE === 'homolog') {
	url = "https://dev-api.v3.fastfrete.com.br";
} else {
	url = "https://api.v3.fastfrete.com.br";
}

export const Constants = {
	url,
	baseUrl: url + "/api/admin",
	baseUrlV2: url + "/api/v2/web/admin",
	baseUrlCargas: url + "/api/admin/gestao-de-cargas",
	baseUrlPatios: url + "/api/admin/gestao-de-patios",
	baseUrlGestaoDeLotesEProgramacao: url + "/api/admin/gestao-de-cargas/gestao-de-agendamento-e-lotes"
	
};
